/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMLoginLessMethodPayload } from '@/data/types/GTM';

export const getGTMLoginLessMethodEventData = (payload: GTMLoginLessMethodPayload) => ({
	login_step: payload.login_step,
	auth_method: payload.auth_method,
	login_origin: payload.login_origin,
});
